import React from "react";
import Hero from "../components/Hero";
import WhyChoose from "../components/WhyChoose";
import Stats from "../components/Stats";
import SummerSpecials from "../components/SummerSpecials";
import QualifySection from "../components/QualifySection";
import Services from "../components/Services";
import Testimonials from "../components/Testimonials";
import Certifications from "../components/Certifications";
import ServiceAreas from "../components/ServiceAreas";
import FAQ from "../components/FAQ";
import ContactForm from "../components/ContactForm";
import useSEO from "../hooks/useSEO";

const Home = () => {
  useSEO({
    title: "Roofing Contractor Washington DC & NoVA | Fab Build Pro",
    description: "Fab Build Pro is a licensed roofing & general contractor serving Washington DC, Northern Virginia & Maryland. Free estimates — call 703-766-6599.",
  });
  return (
    <>
      <Hero />
      <WhyChoose />
      <SummerSpecials />
      <Stats />
      <QualifySection />
      <Services withImages />
      <Testimonials />
      <Certifications />
      <ServiceAreas />
      <FAQ />
      <ContactForm />
    </>
  );
};

export default Home;
